import { NgModule } from '@angular/core';
import { PaymentsModule } from 'src/app/shared/shared/payments.module';
import { SharedModule } from 'src/app/shared/shared/shared.module';
import { CartComponent } from './cart/cart.component';
import { CheckOutCartComponent } from './check-out/check-out-cart/check-out-cart.component';
import { CheckOutCompleteComponent } from './check-out/check-out-complete/check-out-complete.component';
import { CheckOutDueTimeSelectComponent } from './check-out/check-out-due-time-select/check-out-due-time-select.component';
import { CheckOutFooterComponent } from './check-out/check-out-footer/check-out-footer.component';
import { CheckOutOrderDetailsComponent } from './check-out/check-out-order-details/check-out-order-details.component';
import { CheckOutOrderTypeFieldsComponent } from './check-out/check-out-order-type-fields/check-out-order-type-fields.component';
import { CheckOutOrderTypeSelectComponent } from './check-out/check-out-order-type-select/check-out-order-type-select.component';
import { CheckOutPaymentSelectComponent } from './check-out/check-out-payment-select/check-out-payment-select.component';
import { CheckOutPromoCodesComponent } from './check-out/check-out-promo-codes/check-out-promo-codes.component';
import { CheckOutTipSelectComponent } from './check-out/check-out-tip-select/check-out-tip-select.component';
import { CheckOutComponent } from './check-out/check-out.component';
import { OrderStatusComponent } from './check-out/order-status/order-status.component';
import { KioskPaymentComponent } from './kiosk-payment/kiosk-payment.component';
import { LicenseCredentialPromptComponent } from './license-credential-prompt/license-credential-prompt.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { OnlineOrderRoutingModule } from './online-order-routing.module';
import { OnlineOrderComponent } from './online-order.component';
import { OrderTypeTimeChangeComponent } from './order-type-time-change/order-type-time-change.component';
import { ShareCheckComponent } from './share-check/share-check.component';

@NgModule({
	declarations: [
		OnboardingComponent,
		OnlineOrderComponent,
		OrderTypeTimeChangeComponent,
		OrderStatusComponent,
		CartComponent,
		CheckOutOrderTypeSelectComponent,
		CheckOutDueTimeSelectComponent,
		CheckOutOrderTypeFieldsComponent,
		CheckOutTipSelectComponent,
		CheckOutOrderDetailsComponent,
		CheckOutFooterComponent,
		CheckOutPaymentSelectComponent,
		CheckOutCompleteComponent,
		CheckOutComponent,
		CheckOutCartComponent,
		CheckOutPromoCodesComponent,
		ShareCheckComponent,
		LicenseCredentialPromptComponent,
		KioskPaymentComponent,
	],
	imports: [SharedModule, OnlineOrderRoutingModule, PaymentsModule],
})
export class OnlineOrderModule {}
